import React from 'react';
import LegalDoc from '../../components/LegalDoc';

export default function CodeOfConduct() {
  return (
    <LegalDoc
      slug="code-of-conduct"
      title="Code of Conduct"
      subtitle="Standards of behaviour for every CARTIE contributor — employees, contractors, and ecosystem partners."
      version="1.0"
      lastReviewed="2026-02-18"
      controls={["CC1.1"]}
    >
      <h2>Our north star</h2>
      <p>CARTIEAI exists to make FinOps <strong>honest</strong>. That commitment to honesty extends to how we treat each other, our customers, and the broader engineering community.</p>

      <h2>1. Customer honesty</h2>
      <ul>
        <li>We never publish savings claims we cannot reproduce on a customer's own data within 30 days.</li>
        <li>We never list features as "available" if they are stubs, mocks, or behind feature-flags hidden from the customer.</li>
        <li>We never use dark patterns in onboarding, pricing, or cancellation flows.</li>
        <li>Our <a href="/honest-scorecard">Honest Scorecard</a> publicly admits feature gaps; we update it on every release.</li>
      </ul>

      <h2>2. Treating each other</h2>
      <ul>
        <li>We assume good intent and challenge respectfully. Disagreement is welcomed; personal attacks are not.</li>
        <li>We don't tolerate harassment, discrimination, or retaliation against anyone — employee, contractor, customer, or community member.</li>
        <li>Reports of misconduct go to the Founder (lakshmi@cartie.ai). Investigated within 5 business days; remediation within 15.</li>
      </ul>

      <h2>3. Conflicts of interest</h2>
      <ul>
        <li>Material conflicts (e.g., spouse works at a customer, advisor role at a competitor) must be disclosed in writing within 5 business days of becoming aware.</li>
        <li>Side projects that compete with CARTIE's roadmap require written approval from the Founder.</li>
      </ul>

      <h2>4. Customer data &amp; confidentiality</h2>
      <ul>
        <li>We never view customer data without a documented support ticket and the customer's signed consent.</li>
        <li>We never share cost data, customer names, or telemetry in public — including marketing materials — without explicit written consent.</li>
        <li>Production access is logged via the cloud credential vault audit trail (CC6.6).</li>
      </ul>

      <h2>5. Acknowledgement</h2>
      <p>Every contributor signs this document during onboarding and re-acknowledges annually. A countersigned PDF is filed in the SOC 2 evidence repository.</p>

      <blockquote>
        If you witness a violation of this Code, you have an obligation — not just a right — to report it. We will not retaliate. We commit to investigating every report we receive.
      </blockquote>
    </LegalDoc>
  );
}
